import { render, staticRenderFns } from "./eg_collapsible_item.vue?vue&type=template&id=445970b5&scoped=true&"
import script from "./eg_collapsible_item.vue?vue&type=script&lang=js&"
export * from "./eg_collapsible_item.vue?vue&type=script&lang=js&"
import style0 from "./eg_collapsible_item.vue?vue&type=style&index=0&id=445970b5&prod&scoped=true&lang=scss&"
import style1 from "./eg_collapsible_item.vue?vue&type=style&index=1&id=445970b5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445970b5",
  null
  
)

export default component.exports